<template>
  <div class="input-group">
    <select
      v-model="operation"
      :disabled="nothingSelected('journal')"
      class="form-control"
      :name="operationFieldName">
      <option v-for="option in operationOptions" :value="option.operation">{{ option.name }}</option>
    </select>
    <div class="input-group-append">
      <input :disabled="nothingSelected('journal') || operation === ''"
             class="btn btn-primary" type="button" value="Apply" v-modal="modalId" />
    </div>
  </div>

  <modal :id="modalId" :title="title">
    <form :id="formId" :action="action" method="POST">

      <div class="text-center" v-if="isDeleting">
        <p>Are you sure you want to delete {{ count }} journal note{{ count > 1 ? 's' : '' }}?</p>
      </div>
      <div class="text-center" v-else-if="isAddingTpa">
        <p>Are you sure you want to add {{ count }} journal note{{ count > 1 ? 's' : '' }} to the TPA
          journal?</p>
      </div>
      <div class="text-center" v-else-if="isRemovingTpa">
        <p>Are you sure you want to remove {{ count }} journal note{{ count > 1 ? 's' : '' }} from the TPA
          journal?</p>
      </div>
      <input type="hidden" name="bulk_operation" :value="operation">
      <input type="hidden" v-for="id in ids" name="bulk_ids[]" :value="id">

      <input type="hidden" name="_method" value="PATCH">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template v-slot:footer>
      <template v-if="isDeleting">
        <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Cancel</button>
        <button type="submit" class="btn btn-danger" :form="formId"><i class="fa fa-fw fa-trash"></i> Delete</button>
      </template>
      <template v-else-if="isAddingTpa">
        <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Cancel</button>
        <button type="submit" class="btn btn-primary" :form="formId"><i class="fa fa-fw fa-plus"></i> Add to TPA Journal
        </button>
      </template>
      <template v-else-if="isRemovingTpa">
        <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Cancel</button>
        <button type="submit" class="btn btn-danger" :form="formId"><i class="fa fa-fw fa-trash"></i> Remove from TPA
          Journal
        </button>
      </template>
    </template>

  </modal>

</template>

<script>

import HasModal from "./mixins/HasModal";
import { mapWritableState, mapState } from 'pinia'
import { useCheckboxListStore } from "../stores/checkboxList"

export default {
  mixins: [HasModal],

  props: {
    // Operation form field name.
    operationFieldName: {
      required: true,
      type: String,
    },

    // List of operations available.
    operations: {
      type: Array,
      required: true
    },

    // Custom id for modal component.
    modalId: {
      type: String,
      default: 'journal-bulk-modal'
    },
    // Form action.
    action: {
      require: true,
      type: String
    },
  },

  data() {
    return {
      operation: '',
    };
  },
  computed: {
    ...mapState(useCheckboxListStore, ['nothingSelected', 'checkedIds']),
    ...mapWritableState(useCheckboxListStore, ['lists']),

    operationOptions() {
      let operations = _.cloneDeep(this.operations);
      operations.unshift({'name': 'Select a group operation…', 'operation': ''});
      return operations;
    },

    ids() {
      return this.checkedIds('journal');
    },

    formId() {
      return this.modalId + "-form"
    },
    title() {
      if (this.isDeleting) return 'Delete Journal Notes';
      else if (this.isAddingTpa) return 'Add Notes to TPA journal';
      else if (this.isRemovingTpa) return 'Remove Notes from TPA journal';

      return '';
    },
    isDeleting() {
      return this.operation === 'delete';
    },
    isAddingTpa() {
      return this.operation === 'add-tpa';
    },
    isRemovingTpa() {
      return this.operation === 'remove-tpa';
    },
    count() {
      return this.ids.length;
    }
  }
}
</script>
